import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from '@mui/material/styles'
import { palette } from './palette'
// import { typography } from './typography' // Вы можете раскомментировать это, если у вас есть файл с типографикой
import { useStores } from '../app/providers/withStore'

const ThemeProvider = observer(({ children }) => {
  const { themeStore } = useStores()

  const themeOptions = useMemo(
    () => ({
      // Предполагается, что у вас есть палитра для светлой и темной темы
      // Вызываем функцию palette с текущим режимом, а не обращаемся к свойству
      palette: palette(themeStore.mode),
      // typography,
    }),
    [themeStore.mode],
  )

  const theme = createTheme(themeOptions)

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
})

export default ThemeProvider
